import React from 'react';
import cls from 'classnames';

export interface IYoutubePlayer {
  videoId: string;
  className?: string;
}
export const YoutubePlayer: React.FC<IYoutubePlayer> = (props) => {
  const { videoId, className } = props;
  return (
    <div className="video-outer-wrapper">
      <div className={cls('rounded-xl overflow-hidden video-inner-wrapper', className)}>
        <iframe
          width="100%"
          height="100%"
          src={`https://www.youtube.com/embed/${videoId}`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Embedded youtube"
        />
      </div>
    </div>
  );
};
